import { __decorate } from "tslib";
import { Component, Mixins } from 'vue-property-decorator';
import ViewportSizeMixin from '../helpers/mixins/ViewportSizeMixin';
/* eslint-disable no-useless-escape */
const EMAIL_REGEXP = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
let SubscribeNewsletterForm = class SubscribeNewsletterForm extends Mixins(ViewportSizeMixin) {
    constructor() {
        super(...arguments);
        this.email = '';
        this.valid = false;
    }
    emailRules(value) {
        return [
            () => !!value || 'E-mail is required',
            () => EMAIL_REGEXP.test(value) || 'E-mail must be valid',
        ];
    }
    get sendyURL() {
        return process.env.VUE_APP_SENDY_URL;
    }
    get sendyListId() {
        return process.env.VUE_APP_SENDY_NEWSLETTER_LIST_ID;
    }
    onSubmit($event) {
        $event.preventDefault();
    }
};
SubscribeNewsletterForm = __decorate([
    Component
], SubscribeNewsletterForm);
export default SubscribeNewsletterForm;
